import { useQuery } from "convex/react";
import { useUser } from "@clerk/clerk-react";
import { api } from "../../../../convex/_generated/api";

/**
 * Hook to get the current user's data from Convex
 * Returns the user ID and other user information needed for messaging
 */
export function useCurrentUser() {
  const { user: clerkUser, isLoaded } = useUser();

  // Get user data from Convex
  const userData = useQuery(api.users.getCurrentUser, clerkUser ? {} : "skip");

  return {
    userId: userData?._id,
    user: userData,
    isLoaded: isLoaded && userData !== undefined,
    clerkUser,
  };
}
